import styled from 'styled-components';
import { Layout, Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
    display: none;
    
    @media (max-width: 992px) {
        display: block;
    }
`;

export const StyledFooter = styled(Layout.Footer)`
    background-color: transparent;
    border: 0;
`;

export const StyledBackTop = styled.div`
    position: fixed;
    bottom: 10px;
    right: 10px;
`;
